import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useLocalizaciones } from '../../hooks/useLocalizations';
import LocalizationsDashboard from '../../components/administracion/localizaciones/LocalizationsDashboard';

const LocalizacionesPage = () => {
  const { localizaciones, error, isLoading  } = useLocalizaciones();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">Error al cargar personas.</Alert>;

  return (
    <Box sx={{ p: 2 }}>
      <LocalizationsDashboard
        windows={localizaciones}
        onReorder={(newOrder) => {
          console.log('Nuevo orden de localizaciones:', newOrder);
        }}
      />
    </Box>
  );
};

export default LocalizacionesPage;